import { STATUS_CODE_BY_EVENT_CODE } from 'constants/video/videoselfie';

import { ERROR } from 'constants/video/status';

export const getStatusCodeFromErrorEventCode = eventCode => {
    const statusCode = STATUS_CODE_BY_EVENT_CODE[eventCode];
    if (statusCode) return statusCode;

    return ERROR;
};
